import React from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "573102767675";

  const rawMessage =
    "¡Hola! Gracias por comunicarte con VASCO Solutions.%0A" +
    "Somos especialistas en hosting, VPS, diseño web, desarrollo personalizado, SEO, SSL y seguridad de la información.%0A%0A" +
    "Ayudamos a empresas y emprendedores a impulsar su presencia digital con soluciones seguras, escalables y efectivas.%0A%0A" +
    "Cuéntanos brevemente qué necesitas y te ofreceremos la mejor opción para tu proyecto.%0A%0A" +
    "Para empezar, indícanos una de estas opciones:%0A" +
    "1 Página web o tienda online%0A" +
    "2 Hosting o VPS%0A" +
    "3 Posicionamiento SEO%0A" +
    "4 Certificados SSL%0A" +
    "5 Seguridad y protección de datos";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${rawMessage}`;

  const handleClick = () => {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "click_whatsapp_button", {
        event_category: "engagement",
        event_label: "WhatsApp Button Click",
      });
    }
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  const handleKeyDown = (event) => {
    // Permite activar el botón con Enter o Espacio
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="whatsapp-icon-link"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0} // Hace el elemento enfocable
      aria-label="Contactar a VASCO Solutions por WhatsApp para servicios de hosting, VPS, diseño web, SEO, SSL y seguridad informática en Colombia, Miami y Los Ángeles"
    >
      <img
        src="/img/whatsapp-vasco.webp"
        alt="Botón de WhatsApp para consultas de hosting, VPS, diseño web, SEO, SSL y seguridad informática en Colombia, Miami y Los Ángeles"
        width={60}
        height={60}
      />
    </div>
  );
};

export default WhatsAppButton;